export default function initializeKnowlarityWidget() {
  function setConfig() {
    let config = {
      height: "500px",
      width: "400px",
      src: "https://konnect.knowlarity.com/external/#",
    };
    window.KNW_WIDGET.setUserConfig(config);
  }

  const script = document.createElement("script");
  script.src = "https://konnect.knowlarity.com/external/embed/widget.js";
  script.id = "knw-widget-sdk";
  script.defer = true;
  script.onload = setConfig;
  
  // if (window.location.pathname.startsWith("/lead-details/")) {
    document.body.appendChild(script);
  // }
}
